export const columns = [
  {
    headerName: "번호",
    field: "num",
    width: 120,
  },
  {
    headerName: "등록일시",
    field: "createdAt",
    width: 244,
  },
  {
    headerName: "은행",
    field: "bank",
    width: 204,
  },
  {
    headerName: "계좌번호",
    field: "accountNumber",
    width: 219,
  },
  {
    headerName: "예금주",
    field: "accountName",
    width: 200,
  },
  {
    headerName: "구분",
    field: "status",
    width: 200,
  },
];
